var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "itemSearchWrapper",
      class: { active: _vm.isSearchFocused }
    },
    [
      _vm.isMobile
        ? _c(
            "button",
            { staticClass: "toggleButton", on: { click: _vm.toggleSearch } },
            [_c("icon", { staticClass: "fa-fw", attrs: { icon: "search" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "itemSearch", class: { active: _vm.isSearchFocused } },
        [
          _vm.isSearchFocused
            ? _c(
                "button",
                { staticClass: "closeButton", on: { click: _vm.toggleSearch } },
                [
                  _c("icon", { staticClass: "fa-fw", attrs: { icon: "times" } })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "searchContainer" }, [
            _c(
              "div",
              { staticClass: "position-relative" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-grow-1 position-relative searchInputBox"
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchString,
                          expression: "searchString"
                        }
                      ],
                      ref: "searchInput",
                      staticClass: "search-input flex-grow-1 px-3 py-1",
                      attrs: {
                        type: "search",
                        autofocus: _vm.isShopBuilder,
                        placeholder: _vm.$translate(
                          "Ceres::Template.headerSearchPlaceholder"
                        ),
                        "aria-label": _vm.$translate(
                          "Ceres::Template.headerSearchTerm"
                        )
                      },
                      domProps: { value: _vm.searchString },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchString = $event.target.value
                          },
                          function($event) {
                            return _vm.onValueChanged($event.target.value)
                          }
                        ],
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.search()
                        },
                        focus: function($event) {
                          _vm.isSearchFocused = true
                        },
                        blur: function($event) {
                          return _vm.onBlurSearchField($event)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm._t("search-button", [
                      _c(
                        "button",
                        {
                          staticClass: "search-submit px-3",
                          attrs: {
                            type: "submit",
                            "aria-label": _vm.$translate(
                              "Ceres::Template.headerSearch"
                            )
                          },
                          on: {
                            click: function($event) {
                              return _vm.search()
                            }
                          }
                        },
                        [
                          _c("icon", {
                            staticClass: "fa-fw",
                            attrs: {
                              icon: "search",
                              loading: _vm.autocompleteIsLoading
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.isSearchFocused
                  ? [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasInitialInput,
                              expression: "hasInitialInput"
                            }
                          ],
                          staticClass: "results"
                        },
                        [
                          _vm._t("autocomplete-suggestions", [
                            _c(
                              "div",
                              { staticClass: "autocomplete-suggestions w-100" },
                              [
                                _c("search-suggestion-item", {
                                  attrs: { "suggestion-type": "suggestion" }
                                }),
                                _vm._v(" "),
                                _c("search-suggestion-item", {
                                  attrs: { "suggestion-type": "category" }
                                }),
                                _vm._v(" "),
                                _c("search-suggestion-item", {
                                  attrs: {
                                    "show-images": true,
                                    "padding-classes": "",
                                    "suggestion-type": "item"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ],
                        2
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }